module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("table-top"), _vm._v(" "), (_vm.pData && _vm.pData.Records) ? _c('l-table-view', {
    attrs: {
      "DataArr": _vm.pData.Records,
      "TableConfig": _vm.TableConfig
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("table-end"), _vm._v(" "), (_vm.pData && _vm.pData.Records && _vm.isShowPagination) ? [_c('el-pagination', {
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "40px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": _vm.currentPageSizeOpts,
      "page-size": _vm.currentPageSize,
      "layout": "total, prev, pager, next,sizes,jumper",
      "total": _vm.pData.TotalCount
    },
    on: {
      "size-change": _vm.onPageSizeChange,
      "current-change": _vm.onPageChange
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69864e55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/table_page_view.vue
// module id = 1289
// module chunks = 169